import axios from "axios";
import Config from "src/config";

const v1_actionEnviarMenagemWhatsapp = (querys, data) => {
    return axios({
        method: "post",
        url:`${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/enviar-mensagem${querys}`,
        data,
        // Sem timeout a requisição podia ficar pendurada indefinidamente: o balão
        // otimista girava para sempre e o tratamento de erro só rodava minutos
        // depois, já com outra conversa aberta. 45s cobre com folga o tempo real
        // do gateway/Meta, e um reenvio manual é protegido pelo dedupe de
        // clientMessageId no backend.
        timeout: 45000,
    });
};

export default v1_actionEnviarMenagemWhatsapp;
